import moment, { type Moment } from 'moment';
import { IoMdArrowBack } from 'react-icons/io';
import React, { useEffect, useState } from 'react';
import type { RouteComponentProps } from 'react-router-dom';

import history from 'utils/history';
import { handleError } from 'utils/errorHandler';

import useTitle from 'hooks/useTitle';

import * as routes from 'constants/routes';

import * as reminderService from 'services/reminder';

import ReminderForm from './ReminderForm';
import Loading from 'components/common/loading/Loading';

type ReminderRouteParams = {
  id?: string;
};

type ReminderRecord = {
  id: number;
  title: string;
  redirectUrl: string | null;
  startDate: Moment;
  endDate: Moment;
};

type Props = RouteComponentProps<ReminderRouteParams>;

const CreateEditReminder: React.FC<Props> = (props) => {
  const reminderId = props.match.params?.id;
  const title = reminderId ? 'Edit Reminder' : 'Add Reminder';
  const setTitle = useTitle();

  useEffect(() => {
    setTitle(title);
  }, [setTitle, title]);

  const [loading, setLoading] = useState(Boolean(reminderId));
  const [reminder, setReminder] = useState<ReminderRecord | null>(null);

  const handleBackClick = () => (history.length > 1 ? history.goBack() : history.push(routes.REMINDERS));

  const refactorReminder = (data: ReminderRecord) => {
    data.startDate = moment(data.startDate);
    data.endDate = moment(data.endDate);
  };

  useEffect(() => {
    if (!reminderId) {
      return;
    }

    const fetchReminder = async () => {
      try {
        const { data } = (await reminderService.fetchReminder(reminderId)) as { data: ReminderRecord };
        refactorReminder(data);
        setReminder(data);
      } catch (err) {
        handleError(err);
        history.push(routes.REMINDERS);
      } finally {
        setLoading(false);
      }
    };

    void fetchReminder();
  }, [reminderId]);

  return (
    <div className="full-scope-card">
      <div className="full-scope-card__header table-header name-wrap">
        <div className="d-flex flex-row">
          <button
            type="button"
            className="btn btn-shrink btn--alternate btn--curved mr-10 d-inline-flex flex-fix"
            onClick={handleBackClick}
          >
            <IoMdArrowBack size="16px" className="mr-5" />
            Back
          </button>
          <div className="d-flex flex-row">
            <div className="table-header">
              <h3>{title}</h3>
            </div>
          </div>
        </div>
      </div>

      {loading ? (
        <div className="loading-min-height">
          <Loading />
        </div>
      ) : (
        <ReminderForm reminder={reminder} />
      )}
    </div>
  );
};

export default CreateEditReminder;
